(function () {
  'use strict';

  var brandPatterns = [
    [/Easy Protein(?:™|®)?/g, 'Easy Protein®'],
    [/EASY Protein(?:™|®)?/g, 'EASY Protein®'],
    [/EASY PROTEIN(?:™|®)?/g, 'EASY PROTEIN®']
  ];
  var normalizedAttributes = ['alt', 'aria-label', 'content', 'placeholder', 'title'];
  var skippedTags = { CODE: true, NOSCRIPT: true, PRE: true, SCRIPT: true, STYLE: true, TEXTAREA: true };

  function normalize(value) {
    if (!value) return value;
    return brandPatterns.reduce(function (result, entry) {
      return result.replace(entry[0], entry[1]);
    }, value);
  }

  function normalizeTextNode(node) {
    if (!node.parentElement || skippedTags[node.parentElement.tagName]) return;
    var normalized = normalize(node.nodeValue);
    if (normalized !== node.nodeValue) node.nodeValue = normalized;
  }

  function normalizeElement(element) {
    normalizedAttributes.forEach(function (attribute) {
      if (!element.hasAttribute(attribute)) return;
      var currentValue = element.getAttribute(attribute);
      var normalized = normalize(currentValue);
      if (normalized !== currentValue) element.setAttribute(attribute, normalized);
    });

    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    var textNode;
    while ((textNode = walker.nextNode())) normalizeTextNode(textNode);
  }

  function normalizeNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      normalizeTextNode(node);
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      normalizeElement(node);
    }
  }

  normalizeElement(document.documentElement);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') {
        normalizeElement(mutation.target);
      } else if (mutation.type === 'characterData') {
        normalizeTextNode(mutation.target);
      } else {
        mutation.addedNodes.forEach(normalizeNode);
      }
    });
  }).observe(document.documentElement, {
    attributeFilter: normalizedAttributes,
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
  });
})();
